import analyitics from '../../lib/wrapAnalytics';

export const sendScreenAnalytics = async (pathName: string) => {
  let screenName: string;
  switch (pathName) {
    case '/':
      screenName = 'Home Screen';
      console.log(screenName);
      break;
    case '/explore':
      screenName = 'Explore Screen';
      console.log(screenName);
      break;
    case '/contact':
      screenName = 'Contact Screen';
      console.log(screenName);
      break;
    default:
      if (pathName.includes('/explore')) {
        screenName = 'Explore Screen';
        console.log(screenName);
      } else {
        screenName = 'Invalid Screen';
        console.log(screenName);
      }
      break;
  }
  await analyitics.trackScreen(screenName);
};
